// extracted by mini-css-extract-plugin
export default {"element":"style_element__w07xk","outline":"style_outline__Pkyy2","image":"style_image__yX6Ac"};